import { ApplicationRef, ComponentRef, Injectable, Injector, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICmsPluginLoaderService } from '../icms-plugin-loader.service';
import { ICmsShortcutsComponent } from './icms-shortcuts.component';

@Injectable()
export class ICmsShortcutsService {
    private componentRef?: ComponentRef<ICmsShortcutsComponent>;
    private injector?: Injector;

    constructor(
        private applicationRef: ApplicationRef,
        private iCmsPluginLoaderService: ICmsPluginLoaderService,
        router: Router
    ) {
        let cleanup: undefined | (() => void);
        let subscription: Subscription | undefined;

        const handleKeyDown = event => {
            if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
                if (!this.componentRef) {
                    event.preventDefault();
                }
                this.createComponent();
            }

            if ((this.componentRef && event.key === 'Escape') || event.key === 'Esc') {
                event.preventDefault();
                this.destroyComponent();
            }
        };

        this.iCmsPluginLoaderService.hasPotentialCmsAccess$.subscribe(canUse => {
            if (cleanup) {
                cleanup();
                cleanup = undefined;
            }

            if (canUse) {
                document.addEventListener('keydown', handleKeyDown);
                subscription = router.events.subscribe(() => {
                    if (this.componentRef) {
                        this.destroyComponent();
                    }
                });

                cleanup = () => {
                    document.removeEventListener('keydown', handleKeyDown);
                    subscription?.unsubscribe();
                };
            }
        });
    }

    registerInjector(injector: Injector): void {
        if (!this.injector) {
            this.injector = injector;
        }
    }

    async createComponent(): Promise<void> {
        if (!this.componentRef) {
            const viewContainerRef = this.applicationRef.components[0]?.injector.get(ViewContainerRef);
            this.componentRef = viewContainerRef.createComponent(ICmsShortcutsComponent, { injector: this.injector });
            document.body.appendChild(this.componentRef.location.nativeElement);
            this.componentRef.changeDetectorRef.detectChanges();

            const offClick = (event: Event) => {
                if (!event.preventOffClick && !(event.target as Element).closest('icms-shortcuts ._content')) {
                    this.destroyComponent();
                }
            };
            setTimeout(() => document.addEventListener('click', offClick), 1000);

            this.componentRef.onDestroy(() => {
                document.removeEventListener('click', offClick);
            });
        }
    }

    destroyComponent(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
            const element = this.componentRef.location.nativeElement as HTMLElement;
            element.parentNode?.removeChild(element);
            this.componentRef = undefined;
        }
    }
}
